var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "admin-content-area",
      attrs: { id: "page-content-wrapper" }
    },
    [_vm._m(0), _vm._v(" "), _c("app-backend-footer")],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "container-fluid xyz" }, [
      _c("div", { staticClass: "page-header-top-container" }, [
        _c("div", { staticClass: "page-name" }, [_vm._v("Typography")])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "admin-page-content" }, [
        _c("div", { staticClass: "typography-main-section col-12 float-l" }, [
          _c("div", { staticClass: "row" }, [
            _c(
              "div",
              { staticClass: "typography-desire-main col-12 float-l" },
              [
                _c("div", { staticClass: "row" }, [
                  _c(
                    "div",
                    {
                      staticClass:
                        "typography-desire-left col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 float-l"
                    },
                    [
                      _c("div", { staticClass: "row" }, [
                        _c(
                          "div",
                          {
                            staticClass:
                              "typography-inner width-full float-l bg-color-ffffff"
                          },
                          [
                            _c(
                              "h3",
                              {
                                staticClass:
                                  "heading-text-24 line-height-28 color-23727b font-text-regular-san width-full float-l"
                              },
                              [_vm._v(" Typography ")]
                            ),
                            _vm._v(" "),
                            _c(
                              "p",
                              {
                                staticClass:
                                  "heading-text-14 line-height-16 color-7a7a7a font-text-regular-san width-full float-l mb-30"
                              },
                              [
                                _vm._v(
                                  " Use tags h1 to h6 for get desire heading. "
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c("h1", { staticClass: "float-l width-full" }, [
                              _vm._v("h1. heading")
                            ]),
                            _vm._v(" "),
                            _c("h2", { staticClass: "float-l width-full" }, [
                              _vm._v("h2. Sub heading")
                            ]),
                            _vm._v(" "),
                            _c("h3", { staticClass: "float-l width-full" }, [
                              _vm._v("h3. Sub heading")
                            ]),
                            _vm._v(" "),
                            _c("h4", { staticClass: "float-l width-full" }, [
                              _vm._v("h4. Sub heading")
                            ]),
                            _vm._v(" "),
                            _c("h5", { staticClass: "float-l width-full" }, [
                              _vm._v("h5. Sub heading")
                            ]),
                            _vm._v(" "),
                            _c("h6", { staticClass: "float-l width-full" }, [
                              _vm._v("h6. Sub heading")
                            ])
                          ]
                        )
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "typography-desire-right col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 float-l"
                    },
                    [
                      _c("div", { staticClass: "row" }, [
                        _c(
                          "div",
                          {
                            staticClass:
                              "typography-inner width-full float-l bg-color-ffffff"
                          },
                          [
                            _c(
                              "h3",
                              {
                                staticClass:
                                  "heading-text-24 line-height-28 color-23727b font-text-regular-san width-full float-l"
                              },
                              [_vm._v(" Text colors ")]
                            ),
                            _vm._v(" "),
                            _c(
                              "h5",
                              {
                                staticClass:
                                  "heading-text-14 line-height-16 color-7a7a7a font-text-regular-san width-full float-l mb-40"
                              },
                              [
                                _vm._v(
                                  " Use tags below class for get desire text. "
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "h5",
                              {
                                staticClass:
                                  "color-9cadb5 float-l width-full font-text-regular-san pb-10"
                              },
                              [
                                _vm._v("This is an example of muted text.  "),
                                _c("span", { staticClass: "color-444444" }, [
                                  _vm._v(" Add class text-muted ")
                                ])
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "h5",
                              {
                                staticClass:
                                  "color-098de1 float-l width-full font-text-regular-san pb-10"
                              },
                              [
                                _vm._v("This is an example of primary text.  "),
                                _c("span", { staticClass: "color-444444" }, [
                                  _vm._v(" Add class text-primary ")
                                ])
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "h5",
                              {
                                staticClass:
                                  "color-71aa3f float-l width-full font-text-regular-san pb-10"
                              },
                              [
                                _vm._v("This is an example of success text. "),
                                _c("span", { staticClass: "color-444444" }, [
                                  _vm._v(" Add class text-success ")
                                ])
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "h5",
                              {
                                staticClass:
                                  "color-098de1 float-l width-full font-text-regular-san pb-10"
                              },
                              [
                                _vm._v("This is an example of info text. "),
                                _c("span", { staticClass: "color-444444" }, [
                                  _vm._v(" Add class text-info ")
                                ])
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "h5",
                              {
                                staticClass:
                                  "color-ffbb44 float-l width-full font-text-regular-san pb-10"
                              },
                              [
                                _vm._v("This is an example of warning text. "),
                                _c("span", { staticClass: "color-444444" }, [
                                  _vm._v(" Add class text-warning ")
                                ])
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "h5",
                              {
                                staticClass:
                                  "color-c3202b float-l width-full font-text-regular-san"
                              },
                              [
                                _vm._v("This is an example of danger text.  "),
                                _c("span", { staticClass: "color-444444" }, [
                                  _vm._v(" Add class text-danger ")
                                ])
                              ]
                            )
                          ]
                        )
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _vm._v(
                    "\n                            .\n                            "
                  ),
                  _c(
                    "div",
                    {
                      staticClass: "typography-text-para col-12 float-l mt-40"
                    },
                    [
                      _c("div", { staticClass: "row" }, [
                        _c(
                          "div",
                          {
                            staticClass:
                              "typography-address col-12 col-sm-3 col-md-3 col-lg-3 col-xl-3 width-full"
                          },
                          [
                            _c("div", { staticClass: "row" }, [
                              _c(
                                "h3",
                                {
                                  staticClass:
                                    "color-23727b font-text-regular-san width-full float-l mb-0 pb-2"
                                },
                                [_vm._v(" Address ")]
                              ),
                              _vm._v(" "),
                              _c(
                                "h6",
                                {
                                  staticClass:
                                    "color-444444 heading-text-17 line-height-22 font-text-regular-san width-full float-l pb-15"
                                },
                                [_vm._v(" Use address for get desire address ")]
                              ),
                              _vm._v(" "),
                              _c("p", [
                                _vm._v(" Velocity Vehicle Group "),
                                _c("br"),
                                _vm._v(
                                  "\n                                                795 Folsom Ave, Suite 600  "
                                ),
                                _c("br"),
                                _vm._v(
                                  "\n                                                San Francisco, CA 94107 "
                                )
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "btm-contact-detail width-full float-l mt-10"
                                },
                                [
                                  _c(
                                    "p",
                                    {
                                      staticClass:
                                        "heading-text-17 line-height-21 color-444444 font-text-regular-san"
                                    },
                                    [
                                      _c("span", [
                                        _c("i", {
                                          staticClass: "hi-icon icon-abmcontact"
                                        })
                                      ]),
                                      _vm._v(" P:(123) 456-7890 ")
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "p",
                                    {
                                      staticClass:
                                        "heading-text-17 line-height-21 color-444444 font-text-regular-san",
                                      attrs: { href: "#" }
                                    },
                                    [
                                      _c("span", [
                                        _c("i", {
                                          staticClass:
                                            "hi-icon icon-abmenvelope"
                                        })
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "a",
                                        {
                                          staticClass: "color-444444",
                                          attrs: {
                                            href:
                                              "mailto:first.last@example.com"
                                          }
                                        },
                                        [_vm._v(" first.last@example.com ")]
                                      )
                                    ]
                                  )
                                ]
                              )
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "para-justify col-12 col-sm-4 col-md-4 col-lg-4 col-xl-4 width-full"
                          },
                          [
                            _c("div", { staticClass: "row" }, [
                              _c(
                                "h3",
                                {
                                  staticClass:
                                    "color-23727b font-text-regular-san width-full float-l mb-0 pb-2"
                                },
                                [_vm._v(" Paragraph with justify ")]
                              ),
                              _vm._v(" "),
                              _c(
                                "h6",
                                {
                                  staticClass:
                                    "color-444444 heading-text-17 line-height-22 font-text-regular-san width-full float-l pb-15"
                                },
                                [
                                  _vm._v(
                                    " Use tags text-justify for get desire paragraph. "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "btm-contact-detail width-full float-l mt-10"
                                },
                                [
                                  _c(
                                    "p",
                                    {
                                      staticClass:
                                        "heading-text-17 line-height-21 color-444444 font-text-regular-san text-justify"
                                    },
                                    [
                                      _vm._v(
                                        " Ambitioni dedisse scripsisse iudicaretur. Cras mattis iudicium purus sit amet fermentum. Donec sed odio operae, eu vulputate felis rhoncus. Praeterea iter est quasdam res quas ex communi. At nos hinc posthac, sitientis piros Afros. Petierunt uti sibi concilium totius Galliae in diem certam indicere. Cras mattis iudicium purus sit amet fermentum."
                                      )
                                    ]
                                  )
                                ]
                              )
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "blockquotes-manual col-12 col-sm-5 col-md-5 col-lg-5 col-xl-5 width-full"
                          },
                          [
                            _c("div", { staticClass: "row" }, [
                              _c(
                                "h3",
                                {
                                  staticClass:
                                    "color-23727b font-text-regular-san width-full float-l mb-0 pb-2"
                                },
                                [_vm._v(" Blockquotes ")]
                              ),
                              _vm._v(" "),
                              _c(
                                "h6",
                                {
                                  staticClass:
                                    "color-444444 heading-text-17 line-height-22 font-text-regular-san width-full float-l pb-15"
                                },
                                [
                                  _vm._v(
                                    " Use blockquote for get desire address. "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "blockquote-aum width-full float-l mt-10"
                                },
                                [
                                  _c(
                                    "blockquote",
                                    {
                                      staticClass:
                                        "blockquote-aum-para float-l colpie-76"
                                    },
                                    [
                                      _c(
                                        "p",
                                        {
                                          staticClass:
                                            "mb-0 color-444444 heading-text-17 line-height-26 font-text-regular-san width-full float-l"
                                        },
                                        [
                                          _vm._v(
                                            "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer posuere erat a ante."
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "blockquote-aum width-full float-l"
                                },
                                [
                                  _c(
                                    "blockquote",
                                    {
                                      staticClass:
                                        "blockquote-aum-para float-l colpie-76"
                                    },
                                    [
                                      _c(
                                        "p",
                                        {
                                          staticClass:
                                            "mb-0 color-444444 heading-text-17 line-height-26 font-text-regular-san width-full float-l"
                                        },
                                        [
                                          _vm._v(
                                            "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer posuere erat a ante."
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "p",
                                        {
                                          staticClass:
                                            "blockquote-footer mb-0 mt-20 color-c3202b heading-text-15 line-height-26 font-text-medium-san width-full float-l"
                                        },
                                        [
                                          _vm._v(
                                            "Someone famous in Source Title"
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                ]
                              )
                            ])
                          ]
                        )
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "typography-listing-main col-12 float-l mt-40"
                    },
                    [
                      _c("div", { staticClass: "row" }, [
                        _c(
                          "div",
                          {
                            staticClass:
                              "listing-detail-normal float-l col-12 col-sm-4 col-md-4 col-lg-4 col-xl-4"
                          },
                          [
                            _c("div", { staticClass: "row" }, [
                              _c(
                                "h3",
                                {
                                  staticClass:
                                    "color-23727b font-text-regular-san width-full float-l mb-0 pb-2"
                                },
                                [_vm._v(" Ul Listing ")]
                              ),
                              _vm._v(" "),
                              _c(
                                "h6",
                                {
                                  staticClass:
                                    "color-444444 heading-text-17 line-height-22 font-text-regular-san width-full float-l pb-15"
                                },
                                [
                                  _vm._v(
                                    " Use tags ul > li for get desire ol list. "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "listing-detail-aum-normal float-l width-full"
                                },
                                [
                                  _c("ul", { staticClass: "pl-15" }, [
                                    _c(
                                      "li",
                                      {
                                        staticClass:
                                          "color-444444 heading-text-17 line-height-22 font-text-regular-san width-full float-l mb-8"
                                      },
                                      [_vm._v("Lorem ipsum dolor sit amet")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "li",
                                      {
                                        staticClass:
                                          "color-444444 heading-text-17 line-height-22 font-text-regular-san width-full float-l mb-8"
                                      },
                                      [_vm._v("Lorem ipsum dolor sit amet")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "li",
                                      {
                                        staticClass:
                                          "color-444444 heading-text-17 line-height-22 font-text-regular-san width-full float-l mb-8"
                                      },
                                      [_vm._v("Lorem ipsum dolor sit amet")]
                                    )
                                  ])
                                ]
                              )
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "listing-detail-fancy float-l col-12 col-sm-4 col-md-4 col-lg-4 col-xl-4"
                          },
                          [
                            _c("div", { staticClass: "row" }, [
                              _c(
                                "h3",
                                {
                                  staticClass:
                                    "color-23727b font-text-regular-san width-full float-l mb-0 pb-2"
                                },
                                [_vm._v(" Fancy Listing 1 ")]
                              ),
                              _vm._v(" "),
                              _c(
                                "h6",
                                {
                                  staticClass:
                                    "color-444444 heading-text-17 line-height-22 font-text-regular-san width-full float-l pb-15"
                                },
                                [
                                  _vm._v(
                                    " Use tags ul > li for get desire ol list.  "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "listing-detail-aum-fancy float-l width-full"
                                },
                                [
                                  _c("ul", { staticClass: "pl-15" }, [
                                    _c(
                                      "li",
                                      {
                                        staticClass:
                                          "color-444444 heading-text-17 line-height-22 font-text-regular-san width-full float-l mb-8"
                                      },
                                      [_vm._v("Lorem ipsum dolor sit amet")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "li",
                                      {
                                        staticClass:
                                          "color-444444 heading-text-17 line-height-22 font-text-regular-san width-full float-l mb-8"
                                      },
                                      [_vm._v("Lorem ipsum dolor sit amet")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "li",
                                      {
                                        staticClass:
                                          "color-444444 heading-text-17 line-height-22 font-text-regular-san width-full float-l mb-8"
                                      },
                                      [_vm._v("Lorem ipsum dolor sit amet")]
                                    )
                                  ])
                                ]
                              )
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "listing-detail-href float-l col-12 col-sm-4 col-md-4 col-lg-4 col-xl-4"
                          },
                          [
                            _c("div", { staticClass: "row" }, [
                              _c(
                                "h3",
                                {
                                  staticClass:
                                    "color-23727b font-text-regular-san width-full float-l mb-0 pb-2"
                                },
                                [_vm._v(" Fancy Listing with href ")]
                              ),
                              _vm._v(" "),
                              _c(
                                "h6",
                                {
                                  staticClass:
                                    "color-444444 heading-text-17 line-height-22 font-text-regular-san width-full float-l pb-15"
                                },
                                [
                                  _vm._v(
                                    "Use class list-iconsto ul for get desire ol list. "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "listing-detail-aum-href float-l width-full"
                                },
                                [
                                  _c("ul", { staticClass: "pl-15" }, [
                                    _c(
                                      "li",
                                      {
                                        staticClass:
                                          "color-444444 heading-text-17 line-height-22 font-text-regular-san width-full float-l mb-8"
                                      },
                                      [
                                        _c(
                                          "a",
                                          {
                                            staticClass: "color-444444",
                                            attrs: { href: "#" }
                                          },
                                          [
                                            _vm._v(
                                              " Lorem ipsum dolor sit amet "
                                            )
                                          ]
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "li",
                                      {
                                        staticClass:
                                          "color-444444 heading-text-17 line-height-22 font-text-regular-san width-full float-l mb-8"
                                      },
                                      [
                                        _c(
                                          "a",
                                          {
                                            staticClass: "color-444444",
                                            attrs: { href: "#" }
                                          },
                                          [
                                            _vm._v(
                                              " Lorem ipsum dolor sit amet "
                                            )
                                          ]
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "li",
                                      {
                                        staticClass:
                                          "color-444444 heading-text-17 line-height-22 font-text-regular-san width-full float-l mb-8"
                                      },
                                      [
                                        _c(
                                          "a",
                                          {
                                            staticClass: "color-444444",
                                            attrs: { href: "#" }
                                          },
                                          [
                                            _vm._v(
                                              " Lorem ipsum dolor sit amet "
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  ])
                                ]
                              )
                            ])
                          ]
                        )
                      ])
                    ]
                  )
                ])
              ]
            )
          ])
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7b8e93bf", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7b8e93bf","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/typography.vue
// module id = null
// module chunks = 